import { loadStripe } from "@stripe/stripe-js";

const stripePromiseCache = new Map();

export function getStripePromise(apiBaseUrl) {
  const baseUrl =
    apiBaseUrl || process.env.REACT_APP_API_BASE_URL;

  if (stripePromiseCache.has(baseUrl)) {
    return stripePromiseCache.get(baseUrl);
  }

  const stripePromise = (async () => {
    const envKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

    try {
      const response = await fetch(`${baseUrl}/api/subscription-new/stripe-config`);
      if (response.ok) {
        const data = await response.json();
        if (data?.publishableKey && String(data.publishableKey).startsWith("pk_")) {
          return loadStripe(data.publishableKey);
        }
      }
    } catch (_error) {
      // Fall back to build-time key if config endpoint is unavailable.
    }

    if (envKey && String(envKey).startsWith("pk_")) {
      return loadStripe(envKey);
    }

    throw new Error("Stripe publishable key is missing or invalid");
  })();

  stripePromiseCache.set(baseUrl, stripePromise);
  return stripePromise;
}
